<script setup lang="ts">
import { tw } from "../../../utils/tailwind";
import CarouselButton from "../../ui/carousel/CarouselButton.vue";
import type { WithClassAsProps } from "../../ui/carousel/interface";
import { useCarousel } from "../../ui/carousel/useCarousel";

const props = defineProps<WithClassAsProps>();

const { orientation, canScrollNext, scrollNext } = useCarousel();

function next() {
    scrollNext();
}
</script>

<template>
  <CarouselButton
    :disabled="!canScrollNext"
    :class="tw(
      'touch-manipulation disabled:opacity-50',
      props.class,
    )"
    variant="outline"
    @click="next"
  >
    <slot>
        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
            <path d="M25 17L29 21L25 25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 21L29 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="sr-only">Next Slide</span>
    </slot>
  </CarouselButton>
</template>
